/**
 * @file: number report
 * @author: wence
 */
import React, {PureComponent} from 'react';
import PropType from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import {Toast} from 'antd-mobile';

import {postNumberReport} from '../../actions/numberOptionsActions';
import {getInstanceId, applyInspectionForm} from '../../actions/productAction';

import {bAntiBotSend} from '../../util';
import {FormItem} from '../numberOptions/formCom';
import {validateRequire, validateMin, validateEmail, validatePhone, validateMax} from '../numberOptions/utils';

class NumberReport extends PureComponent {
    static propTypes = {
        postNumberReport: PropType.func,
        reportRes: PropType.object,
        match: PropType.object,
        userInfo: PropType.object
    }

    constructor(props) {
        super(props);

        this.state = {
            params: {},
            instanceId: ''
        };
    }

    validate = [];

    onChange = (key, value) => {
        this.setState({params: {...this.state.params, [key]: value}});
    }

    onBlur = () => {
        if (this.isIOS) {
            this.setState({fixed: false});

            document.querySelector('.nav-bar').style.position = '';
        }

    }

    onFocus = () => {
        if (this.isIOS) {
            this.setState({fixed: true});

            document.querySelector('.nav-bar').style.position = 'absolute';
        }
    }

    onSubmit = async () => {
        let canSubmit = true;
        this.validate.map(fn => {
            const vilidate = fn();

            if (vilidate.validate && canSubmit) {
                canSubmit = false;
            }
        });

        if (canSubmit) {
            const resInstance = await getInstanceId();
            if (resInstance.status === 0) {
                bAntiBotSend();
                window['__abbaidu_2024_cb'] = async responseData => {
                    const params = this.state.params;
                    let responseDataJson = {};

                    try {
                        responseDataJson = JSON.parse(responseData);
                    }
                    catch (e) {
                        responseDataJson = {};
                    }
                    const res = await applyInspectionForm({
                        data: responseDataJson.data,
                        'key_id': responseDataJson.key_id,
                        sign: responseDataJson.sign,
                        'instance_id': Object.keys(resInstance.data)[0],
                        'company_name': params.companyName,
                        'person_name': params.userName,
                        'mobile': params.phone,
                        'email': params.email,
                        'notes': params.notes,
                        type: 0,
                        'product_name': '工业安防'
                    });

                    if (res.status === 0) {
                        Toast.success(res.data.message);
                        const query = this.getRequest();
                        setTimeout(() => {
                            if (query.url) {
                                window.location.href = decodeURIComponent(query.url);
                            }
                            else {
                                window.history.go(-1);
                            }
                        }, 1000);
                    }
                    else {
                        Toast.error(res.message || res.description || '');
                    }
                };
            }
            else if (resInstance.status === 401) {
                window.location.href = this.loginUrl();
            }
        }
    }

    pushValidate = node => {
        if (node) {
            this.validate.push(node.validate);
        }
    }

    render() {
        return (
            <div className="number-report">
                <div className="number-report-title">
                    申请每天50次免费试用
                </div>
                <div className="number-report-wrapper">
                    <div className="form">
                        <FormItem
                            isRequire
                            value={this.state.params.companyName}
                            onChange={this.onChange.bind(this, 'companyName')}
                            className="first-form-item"
                            type="input"
                            label="公司名称："
                            placeholder="请输入公司名称"
                            comClassName="form-input"
                            ref={this.pushValidate}
                            onBlur={this.onBlur}
                            onFocus={this.onFocus}
                            rules={[
                                validateRequire('公司名称'),
                                validateMin('公司名称', 2, '超出范围，公司名称为2-50个字符'),
                                validateMax('公司名称', 50, '超出范围，公司名称为2-50个字符')
                            ]}
                        />
                        <FormItem
                            isRequire
                            type="input"
                            label="联系人："
                            comClassName="form-input"
                            ref={this.pushValidate}
                            placeholder="请输入联系人"
                            value={this.state.params.userName}
                            onChange={this.onChange.bind(this, 'userName')}
                            onBlur={this.onBlur}
                            onFocus={this.onFocus}
                            rules={[
                                validateRequire('联系人'),
                                validateMin('联系人', 2, '超出范围，联系人为2-20个字符'),
                                validateMax('联系人', 20, '超出范围，联系人为2-20个字符'),
                            ]}
                        />
                        <FormItem
                            type="input"
                            label="联系电话："
                            isRequire
                            comClassName="form-input"
                            placeholder="请输入联系电话"
                            value={this.state.params.phone}
                            onChange={this.onChange.bind(this, 'phone')}
                            ref={this.pushValidate}
                            rules={[
                                validateRequire('联系电话'),
                                {
                                    validate(value) {
                                        let rePhone = /^1[3456789]\d{9}$/;

                                        return !rePhone.test(value);
                                    },
                                    message: '联系电话格式不正确！'
                                }
                            ]}
                            onBlur={this.onBlur}
                            onFocus={this.onFocus}
                        />
                        <FormItem
                            type="input"
                            isRequire
                            label="邮件："
                            comClassName="form-input"
                            placeholder="请输入邮件"
                            value={this.state.params.email}
                            onChange={this.onChange.bind(this, 'email')}
                            ref={this.pushValidate}
                            rules={[
                                validateRequire('邮件'),
                                {
                                    validate(value) {
                                        let reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
                                        return value.length !== 0 && !reg.test(value);
                                    },
                                    message: '邮件格式不正确！'
                                }
                            ]}
                            onBlur={this.onBlur}
                            onFocus={this.onFocus}
                        />
                        <FormItem
                            type="textarea"
                            label="需求描述："
                            isRequire
                            comClassName="form-textarea"
                            value={this.state.params.notes}
                            onChange={this.onChange.bind(this, 'notes')}
                            placeholder="请简要描述POC需求"
                            rules={[
                                validateRequire('需求描述'),
                                validateMin('需求描述', 2, '超出范围，需求描述为2-500个字符'),
                                validateMax('需求描述', 500, '超出范围，需求描述为2-500个字符'),
                            ]}
                            ref={this.pushValidate}
                            onBlur={this.onBlur}
                            onFocus={this.onFocus}
                        />
                        <div onClick={this.onSubmit} className="number-options-btn">提交申请</div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    state => ({
        reportRes: state.postNumberReport,
        userInfo: state.userLoginstate
    }),
    dispatch => bindActionCreators({postNumberReport}, dispatch)
)(NumberReport);



// WEBPACK FOOTER //
// ./src/containers/inspectionApply/index.jsx